import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const MachineLogoIcon = ({ color }: any) => {
  return (
    <SvgIcon sx={{width: "auto"}}> 
      <svg width="159" height="34" viewBox="0 0 159 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M120.796 21.128V25.4H106.828V8.59998H120.484V12.872H112.396V14.84H119.5V18.92H112.396V21.128H120.796Z"
          fill="currentColor"
        />
        <path
          d="M104.099 8.59998V25.4H99.4431L93.0591 17.768V25.4H87.5391V8.59998H92.1951L98.5791 16.232V8.59998H104.099Z"
          fill="currentColor"
        />
        <path d="M79.1484 8.59998H84.8124V25.4H79.1484V8.59998Z" fill="currentColor" />
        <path
          d="M76.4194 8.59998V25.4H70.7554V19.208H65.5234V25.4H59.8594V8.59998H65.5234V14.552H70.7554V8.59998H76.4194Z"
          fill="currentColor"
        />
        <path
          d="M50.688 25.7839C48.912 25.7839 47.312 25.4159 45.888 24.6799C44.464 23.9279 43.344 22.8879 42.528 21.5599C41.728 20.2159 41.328 18.6959 41.328 16.9999C41.328 15.3039 41.728 13.7919 42.528 12.4639C43.344 11.1199 44.464 10.0799 45.888 9.34394C47.312 8.59194 48.912 8.21594 50.688 8.21594C52.32 8.21594 53.776 8.50394 55.056 9.07994C56.336 9.65594 57.392 10.4879 58.224 11.5759L54.648 14.7679C53.608 13.4559 52.384 12.7999 50.976 12.7999C49.792 12.7999 48.84 13.1839 48.12 13.9519C47.4 14.7039 47.04 15.7199 47.04 16.9999C47.04 18.2799 47.4 19.3039 48.12 20.0719C48.84 20.8239 49.792 21.1999 50.976 21.1999C52.384 21.1999 53.608 20.5439 54.648 19.2319L58.224 22.4239C57.392 23.5119 56.336 24.3439 55.056 24.9199C53.776 25.4959 52.32 25.7839 50.688 25.7839Z"
          fill="currentColor"
        />
        <path
          d="M34.3465 22.472H27.9625L26.8345 25.4H21.0745L28.4185 8.59998H33.9865L41.3305 25.4H35.4745L34.3465 22.472ZM32.7865 18.392L31.1545 14.168L29.5225 18.392H32.7865Z"
          fill="currentColor"
        />
        <path
          d="M15 25.4L14.952 17.744L11.304 23.888H8.808L5.16 18.008V25.4H0V8.59998H4.656L10.128 17.552L15.456 8.59998H20.112L20.16 25.4H15Z"
          fill="currentColor"
        />
        <rect x="124.796" width="34" height="34" rx="4" fill="currentColor" />
        <path
          d="M137.111 8.59998H145.391C147.263 8.59998 148.911 8.94398 150.335 9.63198C151.775 10.304 152.887 11.272 153.671 12.536C154.471 13.8 154.871 15.288 154.871 17C154.871 18.712 154.471 20.2 153.671 21.464C152.887 22.728 151.775 23.704 150.335 24.392C148.911 25.064 147.263 25.4 145.391 25.4H137.111V8.59998ZM145.151 20.984C146.367 20.984 147.335 20.64 148.055 19.952C148.791 19.248 149.159 18.264 149.159 17C149.159 15.736 148.791 14.76 148.055 14.072C147.335 13.368 146.367 13.016 145.151 13.016H142.775V20.984H145.151Z"
          fill="white"
        />
        <path d="M128.721 8.59998H134.385V25.4H128.721V8.59998Z" fill="white" />
      </svg>
    </SvgIcon>
  );
};

export default MachineLogoIcon;
